import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _SalesTaxWithHoldingTax, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { TaxSchemeSimulator } from "../../../../admin/ConfImpuestos/TaxScheme/FuncionesTaxScheme/TaxSchemeSimulator";
import { BasicTable, MASK_DECIMAL, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import useModal, { MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";

interface Props {
    idSalesOrder: number;
    salesOrderDate: any;
    issueDate?: any;
    idAccount?: number;
}

export const SalesTaxWithHoldingTax = ({ idSalesOrder, salesOrderDate, issueDate, idAccount }: Props) => {
    const { instance, lista, setLista, bean, setBean } = useDataBean(_SalesTaxWithHoldingTax);
    const [selectedTaxes, setSelectedTaxes] = useState<any[]>([]);
    const catalogDate = issueDate ?? salesOrderDate;

    const modalAdd = useModal("Agregar retenciones a practicar", MODAL_XL);
    const modalDelete = useModal("Eliminar retención", MODAL_SM);

    useEffect(() => {
        getLista();
    }, [idSalesOrder, salesOrderDate, issueDate]);

    const getLista = () => {
        if (idSalesOrder == null || catalogDate == null) {
            setLista([]);
            return;
        }

        instance.getSalesTaxWithHoldingTaxTaxCatalog(idSalesOrder, catalogDate).then((resp: any) => {
            setLista(resp ?? []);
        }).catch((err: any) => toast.error(err));
    };

    const openCreate = () => {
        setSelectedTaxes([]);
        modalAdd.open();
    };

    const createItems = () => {
        if (selectedTaxes.length === 0) {
            toast.error("Seleccione al menos una retención");
            return;
        }

        const invalidTaxes = selectedTaxes.filter((item: any) => {
            const data = item.DataBeanProperties ?? item;
            return data.IDTaxSchemeValue == null || data.TaxBase == null;
        });

        if (invalidTaxes.length > 0) {
            toast.error("Cada retención debe tener ID y base definidos");
            return;
        }

        const taxes = selectedTaxes.map((item: any) => {
            const data = item.DataBeanProperties ?? item;
            return {
                DataBeanProperties: {
                    IDTaxSchemeValue: data.IDTaxSchemeValue,
                    TaxBase: data.TaxBase,
                },
                DataBeanName: "com.quickdataerp.bean.admin.TaxSchemeValue",
            };
        });

        instance.parseTaxSchemaValuesWithHoldingTaxForSalesOrder(
            idSalesOrder,
            salesOrderDate,
            taxes
        ).then(() => {
            toast.success("Retenciones agregadas correctamente");
            modalAdd.close();
            getLista();
        }).catch((err: any) => toast.error(err));
    };

    const deleteItem = () => {
        if (bean.IDSalesTaxWithHoldingTax == null) {
            toast.error("La retención seleccionada no tiene IDSalesTaxWithHoldingTax");
            return;
        }

        instance.deleteSalesTaxWithHoldingTax(idSalesOrder, salesOrderDate, bean.IDSalesTaxWithHoldingTax).then(() => {
            toast.success("Retención eliminada correctamente");
            modalDelete.close();
            getLista();
        }).catch((err: any) => toast.error(err));
    };

    const head = [
        { title: "ID", property: "IDSalesTaxWithHoldingTax", visible: true, mask: MASK_NUMBER },
        { title: "Impuesto", property: "TaxCategoryName", visible: true },
        { title: "Tarifa", property: "TaxCategoryPercent", visible: true, mask: MASK_DECIMAL },
        { title: "Unidades", property: "TaxUnitsTypeName", visible: true },
        { title: "Base de Impuesto", property: "TaxableAmount", visible: true, mask: MASK_MONEY },
        { title: "Valor Retención", property: "TaxAmount", visible: true, mask: MASK_MONEY },
    ];

    const iconButtonsItem = [
        {
            nombre: "Agregar/Modificar retenciones",
            visible: _single.canCreate(),
            icono: "ri-file-add-line",
            evento: openCreate,
        },
    ];

    const rowButtons = (
        <ListMenu listaBotones={[
            {
                titulo: "Eliminar",
                icono: "ri-delete-bin-line",
                visible: _single.canDelete(),
                evento: () => modalDelete.open(),
            },
        ]} />
    );

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        iconButtons={iconButtonsItem}
                        listButtons={rowButtons}
                    />
                </div>
            </div>

            <Modal
                modal={modalAdd.modal}
                updateModal={modalAdd.setModal}
                eventModal={createItems}
                onSubmitLabel="Agregar Retenciones Seleccionadas"
            >
                <TaxSchemeSimulator
                    menuComponent={false}
                    hideInvoiceSelector
                    idAccount={idAccount}
                    _onChange={setSelectedTaxes}
                />
            </Modal>

            <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteItem}>
                <strong>Eliminar retención {bean.IDSalesTaxWithHoldingTax} - {bean.TaxCategoryName}</strong>
            </ModalConfirm>

        </>
    );
};
